import { SvgIconProps } from "@mui/material";

// 4 columns x 2 rows -- matches the "rows x columns" convention used for
// this app's grouped-grid labels (e.g. "2 x 4").
export const TwoByFourGridIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="1" y="2" width="4.75" height="9.25" rx="1.2" />
    <rect x="6.75" y="2" width="4.75" height="9.25" rx="1.2" />
    <rect x="12.5" y="2" width="4.75" height="9.25" rx="1.2" />
    <rect x="18.25" y="2" width="4.75" height="9.25" rx="1.2" />
    <rect x="1" y="12.75" width="4.75" height="9.25" rx="1.2" />
    <rect x="6.75" y="12.75" width="4.75" height="9.25" rx="1.2" />
    <rect x="12.5" y="12.75" width="4.75" height="9.25" rx="1.2" />
    <rect x="18.25" y="12.75" width="4.75" height="9.25" rx="1.2" />
  </svg>
);
